tag text-block
	<self.text-block>
		<div.container>
			<div.title> title
			<div.slot> <slot>

css
	.text-block
		m:4em 0
		d:flex
		jc:center
		px@lg:5%

	.container
		# bd:10px solid amber5/75%
		p:1em 2em
		d:flex
		fld:column
		width: 75%
		shadow: 0px 0px 20px rgba(0,0,0,.25), 20px -20px 0px amber5/75%, -20px 20px 0px red6/75%
		fs@xs:1em
		fs@sm:1.1em
		fs@md:1.25em
		fs@lg:1.50em
		fs@xl:1.75em

		.slot
			flg:1
			d:flex
			fld:column
			c:rgba(0,0,0,.75)

	.title
		fs:2em
		font-style:italic
		ff:serif
		mb:.5em

